import { useTranslate } from 'react-admin'
import { BatteryReplacementSection } from './endOfLife/BatteryReplacementSection'
import { InverterReplacementSection } from './endOfLife/InverterReplacementSection'

const styles = {
  h2: {
    marginTop: 40,
  },
}

export const EndOfLifeModelling = ({ allowEdit, ...props }) => {
  const translate = useTranslate()

  return (
    <>
      <h2 style={styles.h2}>{translate('Hardware End of Life Modelling')}</h2>
      <BatteryReplacementSection allowEdit={allowEdit} {...props} />
      <InverterReplacementSection allowEdit={allowEdit} {...props} />
    </>
  )
}
